import { Link } from 'react-router-dom'
import { homePathForRole, useAuth } from '../auth/AuthContext'
import { EmptyState, PageHeader } from '../components/ui'

export function NotFound() {
  const { role } = useAuth()
  return (
    <>
      <PageHeader title="Page not found" />
      <EmptyState
        title="That screen does not exist"
        body="The link may be old, or the event may have been removed."
        action={
          <Link className="btn btn--sm" to={homePathForRole(role)}>
            Back to the start
          </Link>
        }
      />
    </>
  )
}
